import { createApp } from 'vue'
import { loadTranslations } from '@/js/global/vue-i18n'
import PrivacyCenter from '@/components/home/views/PrivacyCenter.vue'

window.deleteCookie = (name) => {
    if (name === 'cookie_consent') {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'
    } else {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=' + window.location.host + '; path=/'
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=.' + window.location.host + '; path=/'
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=.medicloud.lv; path=/'
    }

    // Show cookie consent pop-up if user deletes a Google Analytics cookie.
    if (name == '_gid' || name.startsWith('_ga')) {
        window.deleteCookie('cookie_consent')
    }

    window.location.reload()
}

window.acceptAllCookies = () => {
    let cookieExpirationDate = new Date

    cookieExpirationDate.setFullYear(cookieExpirationDate.getFullYear() + 1)

    document.cookie = 'cookie_consent=1; expires=' + cookieExpirationDate.toUTCString() + '; path=/'
    window.location.reload()
}

const app = createApp(PrivacyCenter)

loadTranslations(app).then(() => {
    app.mount('#privacy-center-vue')
})
